const _ = require("lodash");
const ErrorUtil = require("../../../shared/ErrorUtil");

const OpsCart = require("./OpsCart");

// Note that all of this needs to avoid interfering with the user when local
// storage is disabled. See core/util/Storage.js for how that behaves.

// Call when a cart order has finished and the cart must be dumped.
const destroyCart = function(cart, storage, now) {
	// There are annoying parallel execution issues with modifying storage and
	// watching for storage updates when multiple tabs are open. Setting
	// finishedCartID must come first.
	if (cart.cartID) {
		storage.setItem("finishedCartID", cart.cartID);
	}
	cart = OpsCart.init(now);
	saveToStorage(cart, storage);
	return cart;
};

const computeStorageCart = function(cart) {
	return _.pick(cart, ["cartID", "items", "lastItemsUpdate"]);
};

const isCurrentCartFinished = function(cart, storage) {
	const storedFinishedID = parseInt(storage.getItem("finishedCartID"), 10);
	return cart && cart.cartID === storedFinishedID;
};

const loadRawFromStorage = function(storage) {
	const storedCart = storage.getItem("cartData");
	let cartData = null;
	try {
		cartData = JSON.parse(storedCart);
		const storedFinishedID = parseInt(storage.getItem("finishedCartID"), 10);
		if (cartData && cartData.cartID === storedFinishedID) {
			cartData = null;
		}
	} catch (error) {
		ErrorUtil.log(
			"E_CART_STORAGE_PARSE",
			"Error parsing the cartData from local storage.",
			{storedCart}
		);
	}
	return cartData;
};

// storedCart is optional, but can be provided if you already called loadRawFromStorage.
const loadFromStorage = function(cart, storage, storedCart) {
	storedCart = storedCart || loadRawFromStorage(storage);
	const origItems = storedCart ? storedCart.items : cart.items;
	const fixedItems = OpsCart.fixCartItems(origItems, cart);
	const newCart = _.extend({}, cart, storedCart, {items: fixedItems});
	newCart.prices = OpsCart.calculatePrices(newCart);
	newCart.itemSuggestions = OpsCart.computeSuggestions(newCart);
	return newCart;
};

const saveToStorage = function(cart, storage) {
	if (isCurrentCartFinished(cart, storage)) {
		return;
	}
	storage.setItem("cartData", JSON.stringify(computeStorageCart(cart)));
};

const syncWithStorage = function(cart, storage) {
	const storedCart = loadRawFromStorage(storage);
	const storedLastUpdate = storedCart ? storedCart.lastItemsUpdate : -Infinity;
	const isMyCartLatest =
		!isCurrentCartFinished(cart, storage) &&
		storedLastUpdate < cart.lastItemsUpdate;
	if (isMyCartLatest) {
		saveToStorage(cart, storage);
	} else {
		cart = loadFromStorage(cart, storage, storedCart);
	}
	return cart;
};

const checkStorageSync = function(cart, storage) {
	if (isCurrentCartFinished(cart, storage)) {
		return false;
	}
	const cartToCheck = computeStorageCart(cart);
	const storedCart = storage.getItem("cartData");
	try {
		// If storage is disabled, storedCart will be falsy.
		return !storedCart || _.isEqual(cartToCheck, JSON.parse(storedCart));
	} catch (error) {
		ErrorUtil.log(
			"E_CART_STORAGE_PARSE",
			"Error parsing the cartData from local storage.",
			{storedCart}
		);
		return true;
	}
};

module.exports = {
	destroyCart,
	loadFromStorage,
	saveToStorage,
	syncWithStorage,
	checkStorageSync,

	isCurrentCartFinished,
};
